<template>
  <v-container
    fluid
    class="pa-0"
    style="position: fixed; bottom: 0; width: 100%; background: #fff; border-top: 1px solid #c1c1c1; height: 60px"
  >
    <v-row class="ma-0" style="height: 60px">
      <v-col cols="4">
        <Order style="z-index: 10000; position: fixed; bottom: 0" :style="isLandscape ? 'left: 30px;' : 'left: -16px;'" />
      </v-col>
      <v-col cols="8" class="d-flex align-center justify-end">
        <ChangeLanguage small />
        <v-btn color="primary" class="text-none ml-5" width="150" variant="flat" @click="reset" @touchend="reset">
          {{ t('Start over') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useStore } from '@/stores/store'
import Order from '@/components/cart/Order.vue'
import ChangeLanguage from '../common/ChangeLanguage.vue'
import { useI18n } from 'vue-i18n'

export default {
  name: 'BottomDrawer',
  components: {
    Order,
    ChangeLanguage,
  },
  setup() {
    const store = useStore()
    const { t, te } = useI18n()

    return {
      store,
      t,
      te,
    }
  },
  data() {
    return {
      clickedReset: false,
    }
  },
  computed: {
    kiosk() {
      return this.store.kiosk
    },
    isLandscape() {
      return this.store.isLandscape
    },
  },
  methods: {
    reset() {
      if (this.clickedReset === true) return
      
      this.clickedReset = true
      setTimeout(() => {
        this.store.reset()
        this.clickedReset = false
      }, 200)
    },
  },
}
</script>
